import EventEmitter from 'eventemitter3'

export const detailEvent = new EventEmitter()

export function onDetailInformationReload(queryKey, data) {
    detailEvent.emit('DETAIL-INFORMATION-RELOAD-' + queryKey, data)
}

export function removeDetailInformationReload(queryKey) {
    detailEvent.removeListener('DETAIL-INFORMATION-RELOAD-' + queryKey)
}

export function onWifiConnectionReload(userId, data) {
    detailEvent.emit('WIFI-CONNECTION-RELOAD-' + userId, data)
}
